import { createAction, handleActions } from 'redux-actions'

const setHsUsers = createAction('MODALS/RAMS_RECORD/SET_HS_USERS')
const resetHsUsers = createAction('MODALS/RAMS_RECORD/RESET_HS_USERS')

const defaultState = []

const reducer = handleActions(
  {
    [setHsUsers]: (state, { payload }) => payload,
    [resetHsUsers]: () => defaultState,
  },
  defaultState,
)

export { setHsUsers, resetHsUsers, reducer }
